import React, { useLayoutEffect, useMemo } from 'react';
import SheinSyncProgressBar from '@/shein-platform/components/SheinSyncProgressBar';
import { useSheinSyncJobs } from '@/shein-platform/context/SheinSyncJobContext';

/**
 * 页面内同步进度槽：挂在查询区上方（页面内容顶部）。
 * 挂载时认领 kinds，避免与布局顶栏全局条重复展示。
 * 所有同步进度统一走 SheinSyncProgressBar。
 */
export default function SheinSyncProgressSlot({ kinds = [], className = '' }) {
  const {
    getBarsForKinds,
    claimSyncKinds,
    releaseSyncKinds,
    cancelTrack,
    cancellingIds,
  } = useSheinSyncJobs();

  const kindsKey = Array.isArray(kinds) ? kinds.join('|') : String(kinds || '');
  const kindList = useMemo(
    () => (Array.isArray(kinds) ? kinds : [kinds]).filter(Boolean).map(String),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [kindsKey],
  );

  useLayoutEffect(() => {
    if (!kindList.length) return undefined;
    claimSyncKinds(kindList);
    return () => releaseSyncKinds(kindList);
  }, [kindsKey, claimSyncKinds, releaseSyncKinds, kindList]);

  const bars = getBarsForKinds(kindList);
  if (!bars.length) return null;

  const slotClass = ['shein-sync-progress-slot', 'shein-sync-progress-slot--page-top', className]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={slotClass} aria-live="polite">
      {bars.map((progress) => (
        <SheinSyncProgressBar
          key={progress.trackId}
          progress={progress}
          onCancel={
            progress.status === 'queued' || progress.status === 'running'
              ? () => cancelTrack(progress.trackId)
              : undefined
          }
          cancelling={cancellingIds.has(progress.trackId)}
        />
      ))}
    </div>
  );
}
